import React, { useContext, useState } from 'react';
import { Button, Dialog, Message } from '@alifd/next';
import locale from 'antd/es/date-picker/locale/zh_TW';
import { Cascader, DatePicker, Form, Input, InputNumber, Select } from 'antd';
import client from '@/lib/feathers';
import Finance from '@/types/database/finance';
import moment from 'moment';
import { FormValues } from './type';
import { createFinanceRecord } from './util';
import axios from 'axios';
import { FinanceDataContext } from '../../..';
const { Item, useForm } = Form;

export default function CreateFinanceRecord({ setTrigger, cascadeArr }) {
  const [visible, setVisible] = useState(false);
  const [form] = useForm<FormValues>();
  const [accountingSubjectName, setAccountingSubjectName] =
    useState<string>('');

  const { accountingSubjects } = useContext(FinanceDataContext);

  const handleFinish = async (value: FormValues) => {
    const houseDetail = (
      await client.service('residentAccountNumbers').find({
        query: {
          householdNumber: value.householdNumber.join('-'),
        },
      })
    ).data[0];
    try {
      const data: Finance = createFinanceRecord(value, houseDetail);
      await axios.post('/ezcon/api/singleFinance', data, {
        headers: {
          authorization: localStorage.getItem('feathers-jwt'),
        },
      });
      setVisible(false);
      setTrigger({});
      Message.success('帳單新增成功');
    } catch (error) {
      console.error(error);
      Message.error('帳單新增失敗');
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setVisible(false);
  };

  return (
    <>
      <Button
        onClick={() => {
          setVisible(true);
          form.resetFields();
        }}
      >
        新增帳單項目
      </Button>
      <Dialog
        title="新增帳單"
        visible={visible}
        onOk={form.submit}
        onCancel={handleCancel}
        onClose={handleCancel}
      >
        <Form
          form={form}
          style={{
            marginTop: '1rem',
            width: '400px',
            height: '400px',
            overflow: 'auto',
          }}
          onFinish={handleFinish}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 24 }}
        >
          {accountingSubjects.length > 0 && (
            <>
              <Item
                name="paymentPeriod"
                label="帳單月份"
                rules={[{ required: true, message: '請選擇帳單月份' }]}
              >
                <DatePicker.MonthPicker
                  locale={locale}
                  disabledDate={(date) =>
                    date.isSameOrBefore(moment(), 'month')
                  }
                />
              </Item>
              <Item
                name="householdNumber"
                label="戶號"
                rules={[{ required: true, message: '請選擇住戶編號' }]}
              >
                <Cascader options={cascadeArr} expandTrigger="hover" />
              </Item>
              <Item
                name="title"
                label="帳目名稱"
                rules={[
                  {
                    required: true,
                    message: '請輸入帳目名稱',
                  },
                ]}
              >
                <Input />
              </Item>

              <Item
                name="accountingSubjectId"
                label="會計科目"
                rules={[{ required: true, message: '請選擇科目' }]}
              >
                <Select
                  placeholder="請選擇科目"
                  onChange={(value) =>
                    setAccountingSubjectName(
                      accountingSubjects.filter((i) => i._id === value)[0]
                        .subjectName
                    )
                  }
                >
                  {accountingSubjects.map((item) => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.subjectName}
                    </Select.Option>
                  ))}
                </Select>
              </Item>
              {accountingSubjectName.indexOf('減免') >= 0 && (
                <Item
                  name="creditSubjectId"
                  label="減免科目"
                  rules={[{ required: true, message: '請選擇科目' }]}
                >
                  <Select placeholder="請選擇科目">
                    {accountingSubjects
                      .filter(
                        (i) =>
                          i.subjectName.split('-')[0] ===
                            accountingSubjectName.split('-')[0] &&
                          !i.subjectName.includes('減免')
                      )
                      .map((item) => (
                        <Select.Option key={item._id} value={item._id}>
                          {item.subjectName}
                        </Select.Option>
                      ))}
                  </Select>
                </Item>
              )}

              <Item
                name="money"
                label="項目金額"
                rules={[{ required: true, message: '請輸入金額' }]}
              >
                <InputNumber />
              </Item>
              <Item name="remark" label="備註">
                <Input.TextArea maxLength={140} />
              </Item>
            </>
          )}
        </Form>
      </Dialog>
    </>
  );
}
